import { render } from "./RejectDelayApply.vue?vue&type=template&id=5c61c0a0&scoped=true"
import script from "./RejectDelayApply.vue?vue&type=script&lang=js"
export * from "./RejectDelayApply.vue?vue&type=script&lang=js"

import "./RejectDelayApply.vue?vue&type=style&index=0&id=5c61c0a0&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c61c0a0"]])

export default __exports__